import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_off_site_canteens_eating_areas_managed_facility'

export const dataPointDefinition = {
  retracedId: 'are_off_site_canteens_eating_areas_managed_facility',
  name: 'Are off-site canteens and eating areas managed by the facility in line with legal requirements?',
  description:
    'Consult applicable legal requirements relating to having and maintaining an off-site eating area and kitchen (e.g. legal requirements to have a canteen depending on size of workforce, separation from work area, space/number of seats, toilet, canteen staff, work clothes, fire safety, storage of food,',
  meta: {
    slcpMeta: {
      key: 'hs-can-2',
      number: 'HS-CAN-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-can-2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29980,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
